export const FETCH_WEB_MAIL = 'FETCH_WEB_MAIL'
export const ADD_WEB_MAIL = 'ADD_WEB_MAIL'
export const UPDATE_WEB_MAIL = 'UPDATE_WEB_MAIL'
export const REMOVE_WEB_MAIL = 'REMOVE_WEB_MAIL'

